import React from 'react'
import { Carousel } from 'antd';

function Slider({ data }) {
    return (
        <div>
            <Carousel autoplay>
                {data.map((obj,index) => (
                    <div key={index}>
                        <img className='w-full h-[220px] object-cover' src={obj?.url} alt="" srcset="" />
                    </div>
                ))}

            </Carousel>
        </div>
    )
}

export default Slider